import { render, staticRenderFns } from "./examList.vue?vue&type=template&id=384d827c&scoped=true"
import script from "./examList.vue?vue&type=script&lang=js"
export * from "./examList.vue?vue&type=script&lang=js"
import style0 from "../asset/css/list.scss?vue&type=style&index=0&id=384d827c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384d827c",
  null
  
)

export default component.exports